"use server";

import { requireServerRole } from "@/lib/guards";
import {
  addAvsInternalAccountSchema,
  editAvsInternalAccountSchema,
  deleteAvsInternalAccountSchema,
} from "@/lib/schemas/avs-internal-accounts";
import { validateParams } from "@/lib/utils";
import { prisma } from "@/prisma";
import z from "zod";
import { GRP_ROLE_ADMIN } from "@/lib/grp";
import { ActionResult } from "@/types/server-action";

export async function deleteAvsInternalAccount(
  params: z.infer<typeof deleteAvsInternalAccountSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const { id } = validateParams(deleteAvsInternalAccountSchema, params);

    await prisma.avsInternalAccount.update({
      where: { id },
      data: { deletedAt: new Date() },
    });

    return { success: true };
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function addAvsInternalAccount(
  params: z.infer<typeof addAvsInternalAccountSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const { sellingType, label, brandLetter, accountNumber, kvps } =
      validateParams(addAvsInternalAccountSchema, params);

    const avsInternalAccount = await prisma.avsInternalAccount.create({
      data: {
        sellingType,
        label,
        brandLetter,
        accountNumber,
        kvps,
        isActive: true,
      },
    });

    return { success: true, data: avsInternalAccount };
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function editAvsInternalAccount(
  params: z.infer<typeof editAvsInternalAccountSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const {
      id = -1,
      sellingType,
      label,
      brandLetter,
      accountNumber,
      kvps,
      isActive = true,
    } = validateParams(editAvsInternalAccountSchema, params);

    const avsInternalAccount = await prisma.avsInternalAccount.update({
      where: { id },
      data: { sellingType, label, brandLetter, accountNumber, kvps, isActive },
    });

    return { success: true, data: avsInternalAccount };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}
